import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
// import { intlReducer } from 'react-intl-redux'
import userReducer from './userReducer'
import responsibleGamingReducer from './account/responsibleGamingReducer'
import uiReducer from './ui/uiReducer'
import verificationReducer from './account/verificationReducer'
import settingsReducer from './settings/settingsReducer'
import seoSettingsReducer from './seo/seoSettingsReducer'
import seoSchemaReducer from './seo/seoSchemaReducer'
import bonusesReducer from './profile/bonusesReducer'
import securityReducer from './profile/securityReducer'
import paymentsReducer from './profile/paymentsReducer'
import cashierReducer from './profile/cashierReducer'

import messagesReducer from './messagesReducer'
import bannersReducer from './bannersReducer'
import businessRulesReducer from './businessRulesReducer'
import staticMessagesReducer from './staticMessagesReducer'
import notificationsReducer from './notificationsReducer'
import gamesReducer from './games/gamesReducer'
import promotionsReducer from './promotionsReducer'
import pagesReducer from './pagesReducer'
import lobbiesReducer from './lobbiesReducer'
import tournamentsReducer from './tournamentsReducer'
import widgetsReducer from './widgetsReducer'
import popupsReducer from './popupsReducer'
import announcementReducer from './announcementReducer'
import freeSpinsReducer from './freeSpinsReducer'
import storiesReducer from './storiesReducer'
import promoToolReducer from './promoToolReducer'
import seoRulesReducer from './seo/seoRulesReducer'
import referFriendReducer from './referFriendReducer'
import bonusReducerV2 from './bonusReducerV2'
import offersReducer from './profile/offersReducer'
import imageSetReducer from './imageSetReducer'
import calendarPromotionsReducer from './calendarReducer'
// import freeSpinsGamesReducer from './freeSpinsGamesReducer'

export default (history) => combineReducers({
  router: connectRouter(history),
  games: gamesReducer,
  translations: staticMessagesReducer,
  user:userReducer,
  account:combineReducers({
    verification: verificationReducer,
    responsibleGaming:responsibleGamingReducer
  }),
  ui: uiReducer,
  messages: messagesReducer,
  settings: settingsReducer,
  seo: combineReducers({
    general: seoSettingsReducer,
    schema: seoSchemaReducer,
    rules: seoRulesReducer
  }),
  banners: bannersReducer,
  imageSet: imageSetReducer,
  businessRules: businessRulesReducer,
  profile: combineReducers({
    bonuses: bonusesReducer,
    payments: paymentsReducer,
    cashier: cashierReducer,
    security: securityReducer,
    freeSpins : freeSpinsReducer
  }),
  notifications: notificationsReducer,
  promotions: promotionsReducer,
  calendarPromotions: calendarPromotionsReducer,
  pages: pagesReducer,
  lobbies: lobbiesReducer,
  tournaments: tournamentsReducer,
  widgets: widgetsReducer,
  popup: popupsReducer,
  announcements: announcementReducer,
  stories: storiesReducer,
  promoTool:promoToolReducer,
  referFriend: referFriendReducer,
  bonusSystem: bonusReducerV2,
  offers: offersReducer,
});
